import { render, staticRenderFns } from "./FilmTypeDetail.vue?vue&type=template&id=756a68a8"
import script from "./FilmTypeDetail.vue?vue&type=script&lang=js"
export * from "./FilmTypeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports